import React, { useState, useCallback } from 'react';
import PreviewModal from './PreviewModal';

export interface Product {
  id: number;
  name: string;
  image: string;
  price: number;
  originalPrice?: number;
  discount?: number;
  rating?: number;
  sold?: string;
  link?: string;
}

interface Props {
  product: Product;
}

const ProductCard: React.FC<Props> = ({ product }) => {
  const [hovered, setHovered] = useState(false);
  const [showPreview, setShowPreview] = useState(false);

  const formatPrice = (price: number) => {
    return price.toLocaleString() + '\uC6D0';
  };

  const openPreview = useCallback((e: React.MouseEvent) => {
    e.stopPropagation();
    e.preventDefault();
    setShowPreview(true);
  }, []);

  const goToDetail = useCallback(() => {
    window.open(`/shop/product/${product.id}`, '_blank');
  }, [product.id]);

  return (
    <>
      <div
        className={`product-card ${hovered ? 'hovered' : ''}`}
        onMouseEnter={() => setHovered(true)}
        onMouseLeave={() => setHovered(false)}
        style={{ position: 'relative' }}
      >
        <div onClick={goToDetail}>
          <div className="product-image-wrap">
            <img
              className="product-image"
              src={product.image}
              alt={product.name}
              loading="lazy"
              onError={(e) => {
                (e.target as HTMLImageElement).src = 'https://via.placeholder.com/300x300?text=No+Image';
              }}
            />
            <div className="product-cart-btn">
              <svg viewBox="0 0 24 24" fill="#fff" width="18" height="18">
                <path d="M7 18c-1.1 0-1.99.9-1.99 2S5.9 22 7 22s2-.9 2-2-.9-2-2-2zM1 2v2h2l3.6 7.59-1.35 2.45c-.16.28-.25.61-.25.96 0 1.1.9 2 2 2h12v-2H7.42c-.14 0-.25-.11-.25-.25l.03-.12.9-1.63h7.45c.75 0 1.41-.41 1.75-1.03l3.58-6.49A1.003 1.003 0 0020.01 4H5.21l-.94-2H1zm16 16c-1.1 0-1.99.9-1.99 2s.89 2 1.99 2 2-.9 2-2-.9-2-2-2z"/>
              </svg>
            </div>
          </div>
          <div className="product-info">
            <div className="product-name">{product.name}</div>
            <div className="product-price">
              <span className="price-current">{formatPrice(product.price)}</span>
              {product.originalPrice && (
                <span className="price-original">{formatPrice(product.originalPrice)}</span>
              )}
              {product.discount && product.discount > 0 && (
                <span className="discount-badge">-{product.discount}%</span>
              )}
            </div>
            {(product.rating || product.sold) && (
              <div className="product-meta">
                {!!product.rating && <span className="rating">{'\u2605'} {product.rating}</span>}
                {product.sold && <span>{product.sold}</span>}
              </div>
            )}
          </div>
        </div>
        {hovered && (
          <div
            className="product-preview-bar"
            onMouseDown={openPreview}
          >
            미리보기
          </div>
        )}
      </div>
      {showPreview && (
        <PreviewModal productId={product.id} onClose={() => setShowPreview(false)} />
      )}
    </>
  );
};

export default ProductCard;
